import {
  useModalStore,
  useWindowSize,
  withErrorBoundary,
} from '@navi-app/utils';
import { Modal, ModalBody, ModalHeader } from 'baseui/modal';
import { HeadingLarge } from 'baseui/typography';
import { useTranslation } from 'react-i18next';
import { TLayout } from '../layout';
import MobileView from './components/mobile-view';
import TutorialCard from './components/tutorial-card';
import VideoSection from './components/video-section';
import useTutorialVideo from './hooks/use-tutorial-video';

type TModalTutorialVideo = {
  config: TLayout['config'];
};

const ModalTutorialVideo = ({ config }: TModalTutorialVideo) => {
  const { t } = useTranslation('modal-tutorial');
  const { modalName, openModal, modalData, closeModal } = useModalStore();

  const { isPhoneSize } = useWindowSize();

  const { activeTutorial, onClickCard, videosArr } = useTutorialVideo(
    t,
    config
  );

  const onClose = () => {
    if (modalData?.isFromNavbar) {
      closeModal();
    } else {
      openModal('modal-welcome-onboard');
    }
  };

  if (isPhoneSize) {
    return (
      <MobileView
        {...activeTutorial}
        videosArr={videosArr}
        onClickCard={onClickCard}
      />
    );
  }

  return (
    <Modal
      isOpen={modalName === 'modalTutorialVideo'}
      onClose={onClose}
      overrides={{
        Dialog: {
          style: {
            marginTop: isPhoneSize ? '68px' : '16px',
            marginRight: isPhoneSize ? '-56px' : '16px',
            marginLeft: isPhoneSize ? '-56px' : '16px',
            width: isPhoneSize ? '80%' : '90%',
            maxWidth: '895px',
            minWidth: '300px',
            minHeight: '560px',
            zIndex: '999',
          },
        },
        Root: {
          style: {
            zIndex: '999',
          },
        },
      }}
    >
      <ModalHeader>
        <HeadingLarge className="!text-[28px]">{t('title')}</HeadingLarge>
      </ModalHeader>
      <ModalBody className="pt-6 min-h-[440px] flex gap-6">
        <div
          className="w-2/5 gap-3 max-h-[500px] overflow-y-auto"
          style={{ scrollbarWidth: 'none' }}
        >
          {videosArr.map((video) => (
            <TutorialCard
              key={video.id}
              {...video}
              isActive={activeTutorial.id === video.id}
              onClickCard={onClickCard}
            />
          ))}
        </div>
        <div className="border-l border-[#E8E8E8] min-h-[440px]"></div>
        <div className="w-3/5">
          <VideoSection {...activeTutorial} t={t} />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default withErrorBoundary(ModalTutorialVideo);
